<template>
    <section class="Section Arianna">
        <div class="Container">
            <div class="BoxWide">
                <div class="AriannaHolder">                   
                    <span v-for="(link, index) in this.linkPagine" :key="index">                        
                        <router-link class="AriannaLink" :to="{'path' : link.to}">{{link.text}}</router-link>
                        <template v-if="this.linkPagine.length > 1">
                            <span class="AriannaSeparatore">&nbsp;</span>
                        </template>
                    </span>
                </div>
                <div class="TheDay">{{  this.oggi  }}</div>
            </div>
        </div>
    </section>
</template>
<script>

import moment from 'moment'
import 'moment/locale/it'
moment.locale('it')

export default{
    name : "BreadCrumbs",
    data(){
        return {
            linkPagine: [],           
            lastLinkDescription : ""
        }
    }, 
    computed: {
        oggi: function(){
            let now = moment();
            return now.format('dddd') + " " + now.format("L");
        }
    }, 
    // mounted: function(){      
    //     this.linkPagine = this.$route.meta.breadCrumbs;
    // },
    props:{
        extraData: String,
        breadCrumbs: Array
    },
    watch:{
        breadCrumbs: function(newValue){
            this.linkPagine = newValue;
        }
    }
}
</script>